export default `
<!-- Generated by ai2html v0.99.2 - 2020-03-02 14:25 -->
<!-- ai file: ai2html-chart.ai -->
<style media="screen,print">
	#g-ai2html-chart-box ,
	#g-ai2html-chart-box .g-artboard {
		margin:0 auto;
	}
	#g-ai2html-chart-box p {
		margin:0;
	}
	#g-ai2html-chart-box .g-aiAbs {
		position:absolute;
	}
	#g-ai2html-chart-box .g-aiImg {
		position:absolute;
		top:0;
		display:block;
		width:100% !important;
	}
	#g-ai2html-chart-box .g-aiSymbol {
		position: absolute;
		box-sizing: border-box;
	}
	#g-ai2html-chart-box .g-aiPointText p { white-space: nowrap; }
	#g-ai2html-chart-wide {
		position:relative;
		overflow:hidden;
	}
	#g-ai2html-chart-wide p {
		font-family:Open Sans,sans-serif;
		font-weight:400;
		line-height:17px;
		height:auto;
		filter:alpha(opacity=100);
		-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
		opacity:1;
		letter-spacing:0em;
		font-size:14px;
		text-align:left;
		color:rgb(0,0,0);
		text-transform:none;
		padding-bottom:0;
		padding-top:0;
		mix-blend-mode:normal;
		font-style:normal;
		position:static;
	}
	#g-ai2html-chart-wide .g-pstyle0 {
		font-weight:600;
		line-height:18px;
		height:18px;
		font-size:15px;
	}
	#g-ai2html-chart-wide .g-pstyle1 {
		height:17px;
	}
	#g-ai2html-chart-wide .g-pstyle2 {
		font-weight:600;
		height:17px;
	}
	#g-ai2html-chart-medium {
		position:relative;
		overflow:hidden;
	}
	#g-ai2html-chart-medium p {
		font-family:Open Sans,sans-serif;
		font-weight:400;
		line-height:17px;
		height:auto;
		filter:alpha(opacity=100);
		-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
		opacity:1;
		letter-spacing:0em;
		font-size:14px;
		text-align:left;
		color:rgb(0,0,0);
		text-transform:none;
		padding-bottom:0;
		padding-top:0;
		mix-blend-mode:normal;
		font-style:normal;
		position:static;
	}
	#g-ai2html-chart-medium .g-pstyle0 {
		font-weight:600;
		line-height:18px;
		height:18px;
		font-size:15px;
	}
	#g-ai2html-chart-medium .g-pstyle1 {
		height:17px;
	}
	#g-ai2html-chart-medium .g-pstyle2 {
		font-weight:600;
		height:17px;
	}
	#g-ai2html-chart-small {
		position:relative;
		overflow:hidden;
	}
	#g-ai2html-chart-small p {
		font-family:Open Sans,sans-serif;
		font-weight:400;
		line-height:17px;
		height:auto;
		filter:alpha(opacity=100);
		-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
		opacity:1;
		letter-spacing:0em;
		font-size:14px;
		text-align:left;
		color:rgb(0,0,0);
		text-transform:none;
		padding-bottom:0;
		padding-top:0;
		mix-blend-mode:normal;
		font-style:normal;
		position:static;
	}
	#g-ai2html-chart-small .g-pstyle0 {
		font-weight:600;
		line-height:18px;
		height:18px;
		font-size:15px;
	}
	#g-ai2html-chart-small .g-pstyle1 {
		height:17px;
	}
	#g-ai2html-chart-small .g-pstyle2 {
		font-weight:600;
		height:17px;
	}
	#g-ai2html-chart-mobile {
		position:relative;
		overflow:hidden;
	}
	#g-ai2html-chart-mobile p {
		font-family:Open Sans,sans-serif;
		font-weight:400;
		line-height:17px;
		height:auto;
		filter:alpha(opacity=100);
		-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
		opacity:1;
		letter-spacing:0em;
		font-size:14px;
		text-align:left;
		color:rgb(0,0,0);
		text-transform:none;
		padding-bottom:0;
		padding-top:0;
		mix-blend-mode:normal;
		font-style:normal;
		position:static;
	}
	#g-ai2html-chart-mobile .g-pstyle0 {
		font-weight:600;
		line-height:18px;
		height:18px;
		font-size:15px;
	}
	#g-ai2html-chart-mobile .g-pstyle1 {
		height:17px;
	}
	#g-ai2html-chart-mobile .g-pstyle2 {
		font-weight:600;
		height:17px;
	}

</style>

<div id="g-ai2html-chart-box" class="ai2html">
<p class="chart-title">Headline goes here</p><p class="chart-leadin">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer felis lacus, pulvinar.</p>
	<!-- Artboard: wide -->
	<div id="g-ai2html-chart-wide" class="g-artboard" style="min-width: 920px;" data-aspect-ratio="4.877" data-min-width="920">
<div style="padding: 0 0 20.5039% 0;"></div>
		<img id="g-ai2html-chart-wide-img" class="g-aiImg" alt="" src="ai2html-chart-wide.png"/>
		<div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.264%;margin-top:-10px;left:0.1224%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.264%;margin-top:-10px;left:53.2232%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:0.1237%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:53.2245%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:20.5099%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:73.6107%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:0.1237%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai0-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:53.2245%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai0-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:21.4175%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai0-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:74.4095%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai0-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:0.1237%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai0-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:53.2245%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai0-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:22.521%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai0-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:75.2957%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai0-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:0.1237%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai0-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:53.2245%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai0-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:23.3684%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai0-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:76.1432%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai0-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8418%;margin-top:-9.5px;left:31.1428%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai0-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8418%;margin-top:-9.5px;left:83.7002%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai0-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8001%;margin-top:-9.4px;left:0.1237%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
		<div id="g-ai0-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8001%;margin-top:-9.4px;left:53.2245%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
	</div>

	<!-- Artboard: medium -->
	<div id="g-ai2html-chart-medium" class="g-artboard" style="min-width: 600px;max-width: 919px;max-height: 289px" data-aspect-ratio="3.181" data-min-width="600" data-max-width="919">
<div style="padding: 0 0 31.4394% 0;"></div>
		<img id="g-ai2html-chart-medium-img" class="g-aiImg" alt="" src="ai2html-chart-medium.png"/>
		<div id="g-ai1-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.264%;margin-top:-10px;left:0%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai1-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.264%;margin-top:-10px;left:51.8041%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai1-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:0.002%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai1-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:51.806%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai1-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:29.5871%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai1-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.0049%;margin-top:-9.4px;left:80.9587%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai1-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:0.002%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai1-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:51.806%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai1-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:30.4685%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai1-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9687%;margin-top:-9.4px;left:81.8401%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai1-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:0.002%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai1-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:51.806%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai1-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:30.9878%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai1-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4025%;margin-top:-9.4px;left:82.3594%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai1-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:0.002%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai1-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:51.806%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai1-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:31.778%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai1-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.3663%;margin-top:-9.4px;left:83.1496%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai1-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8418%;margin-top:-9.5px;left:37.1482%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai1-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8418%;margin-top:-9.5px;left:88.5198%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai1-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8001%;margin-top:-9.4px;left:0.002%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
		<div id="g-ai1-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8001%;margin-top:-9.4px;left:51.806%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
	</div>

	<!-- Artboard: small -->
	<div id="g-ai2html-chart-small" class="g-artboard" style="min-width: 420px;max-width: 599px;max-height: 565px" data-aspect-ratio="1.059" data-min-width="420" data-max-width="599">
<div style="padding: 0 0 94.4016% 0;"></div>
		<img id="g-ai2html-chart-small-img" class="g-aiImg" alt="" src="ai2html-chart-small.png"/>
		<div id="g-ai2-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.0287%;margin-top:-10px;left:0.094%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai2-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.945%;margin-top:-9.4px;left:0.0968%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai2-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.945%;margin-top:-9.4px;left:45.4664%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai2-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.0159%;margin-top:-9.4px;left:0.0968%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai2-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.0159%;margin-top:-9.4px;left:46.6969%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai2-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8346%;margin-top:-9.4px;left:0.0968%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai2-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8346%;margin-top:-9.4px;left:49.7217%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai2-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.9054%;margin-top:-9.4px;left:0.0968%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai2-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.9054%;margin-top:-9.4px;left:50.8249%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai2-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7439%;margin-top:-9.5px;left:65.9112%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai2-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7241%;margin-top:-9.4px;left:0.0968%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
		<div id="g-ai2-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4894%;margin-top:-10px;left:0.0488%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai2-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.1535%;margin-top:-9.4px;left:0.0516%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai2-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.1535%;margin-top:-9.4px;left:45.4228%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai2-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2244%;margin-top:-9.4px;left:0.0516%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai2-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2244%;margin-top:-9.4px;left:46.6533%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai2-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.0431%;margin-top:-9.4px;left:0.0516%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai2-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.0431%;margin-top:-9.4px;left:49.6781%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai2-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.114%;margin-top:-9.4px;left:0.0516%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai2-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.114%;margin-top:-9.4px;left:50.7812%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai2-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:94.1958%;margin-top:-9.5px;left:65.8676%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai2-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:94.176%;margin-top:-9.4px;left:0.0516%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
	</div>

	<!-- Artboard: mobile -->
	<div id="g-ai2html-chart-mobile" class="g-artboard" style="max-width: 419px;max-height: 554px" data-aspect-ratio="0.757" data-min-width="0" data-max-width="419">
<div style="padding: 0 0 132.1623% 0;"></div>
		<img id="g-ai2html-chart-mobile-img" class="g-aiImg" alt="" src="ai2html-chart-mobile.png"/>
		<div id="g-ai3-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.0287%;margin-top:-10px;left:-0.1037%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai3-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.4406%;margin-top:-9.4px;left:-0.0998%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai3-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.4406%;margin-top:-9.4px;left:59.618%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai3-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.5115%;margin-top:-9.4px;left:-0.0998%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai3-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.5115%;margin-top:-9.4px;left:60.96%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai3-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5823%;margin-top:-9.4px;left:-0.0998%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai3-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.5823%;margin-top:-9.4px;left:62.549%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai3-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.6532%;margin-top:-9.4px;left:-0.0998%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai3-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.6532%;margin-top:-9.4px;left:64.0288%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai3-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7439%;margin-top:-9.5px;left:75.009%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai3-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7241%;margin-top:-9.4px;left:-0.0998%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
		<div id="g-ai3-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4894%;margin-top:-10px;left:-0.1037%;width:243px;">
			<p class="g-pstyle0">Percent of food left after stage</p>
		</div>
		<div id="g-ai3-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.8925%;margin-top:-9.4px;left:59.618%;width:50px;">
			<p class="g-pstyle1">93%</p>
		</div>
		<div id="g-ai3-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.6491%;margin-top:-9.4px;left:-0.0998%;width:94px;">
			<p class="g-pstyle1">Production</p>
		</div>
		<div id="g-ai3-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.72%;margin-top:-9.4px;left:-0.0998%;width:163px;">
			<p class="g-pstyle1">Handling and Storage</p>
		</div>
		<div id="g-ai3-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.72%;margin-top:-9.4px;left:60.96%;width:50px;">
			<p class="g-pstyle1">90%</p>
		</div>
		<div id="g-ai3-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.7909%;margin-top:-9.4px;left:-0.0998%;width:92px;">
			<p class="g-pstyle1">Processing</p>
		</div>
		<div id="g-ai3-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.7909%;margin-top:-9.4px;left:62.549%;width:50px;">
			<p class="g-pstyle1">87%</p>
		</div>
		<div id="g-ai3-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.8618%;margin-top:-9.4px;left:-0.0998%;width:178px;">
			<p class="g-pstyle1">Distribution and Market</p>
		</div>
		<div id="g-ai3-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.8618%;margin-top:-9.4px;left:64.0288%;width:50px;">
			<p class="g-pstyle1">84%</p>
		</div>
		<div id="g-ai3-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:94.9525%;margin-top:-9.5px;left:75.009%;width:50px;">
			<p class="g-pstyle2">58%</p>
		</div>
		<div id="g-ai3-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:94.9327%;margin-top:-9.4px;left:-0.0998%;width:110px;">
			<p class="g-pstyle1">Consumption</p>
		</div>
	</div>

</div>
<p class="chart-note">Note: Lorem ipsum dolor sit amet</p><p class="chart-source">Source: World Bank</p>
<!-- End ai2html - 2020-03-02 14:25 -->
`
